// src/app/shared/services/utils.service.ts
import { Injectable, Renderer2 } from '@angular/core'
import { environment } from '../../environments/environment'
import { Store } from '@ngrx/store'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { HttpClient } from '@angular/common/http'
import { ApiService } from './api.service'
import { AuthService } from './auth.service'
import { AuthState, selectUser } from '../store/auth/auth.state'
import { map } from 'rxjs'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  public apiEndpoint = environment.apiBaseUrl
  public profilePicture = '../../../../assets/img/user.jpg'
  public businessPicture = '../../../../assets/img/user.jpg'
  public businessData = { businessName: 'string', picture: true }

  user: AuthState['user'] | null = null
  userPicture: Blob | string | SafeUrl | null = null
  userimageObjectURL!: string | null
  businessimageObjectURL!: string | null

  constructor(
    private store: Store,
    // private authService: AuthService
    private http: HttpClient
  ) {
    this.init() // ✅ run initialization in constructor
  }

  private init(): void {
    this.store
      .select(selectUser)
      .pipe(map(user => (this.user = user)))
      .subscribe(user => {
        // if (user?.picture) {
        //   const imageUrl = this.apiEndpoint + '/uploads/' + user.picture
        //   this.authService.getImage(imageUrl).subscribe(
        //     imageBlob => {
        //       this.userPicture = imageBlob
        //       this.userimageObjectURL = URL.createObjectURL(imageBlob)
        //     },
        //     error => console.error('Error fetching image:', error)
        //   )
        // }

        // if (user?.employmentType && user.employmentType !== 'Admin') {
        //   const imageUrl = this.apiEndpoint + '/uploads/' + (user.business?.picture ?? '')
        //   this.authService.getImage(imageUrl).subscribe(
        //     imageBlob => {
        //       this.userPicture = imageBlob
        //       this.businessimageObjectURL = URL.createObjectURL(imageBlob)
        //     },
        //     error => console.error('Error fetching image:', error)
        //   )
        // }

        if (user?.picture) {
          const imageUrl = this.apiEndpoint + '/uploads/' + user.picture
          this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
            imageBlob => {
              this.userPicture = imageBlob
              this.userimageObjectURL = URL.createObjectURL(imageBlob)
            },
            error => console.error('Error fetching image:', error)
          )
        }

        if (user?.employmentType && user.employmentType !== 'Admin') {
          const imageUrl = this.apiEndpoint + '/uploads/' + (user.business?.picture ?? '')
          this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
            imageBlob => {
              this.userPicture = imageBlob
              this.businessimageObjectURL = URL.createObjectURL(imageBlob)
            },
            error => console.error('Error fetching image:', error)
          )
        }
      })
  }

  getInitials(firstName?: string | null, lastName?: string | null): string {
    const f = (firstName ?? '').trim()
    const l = (lastName ?? '').trim()
    return `${f.charAt(0)}${l.charAt(0) || ''}`.toUpperCase()
  }

  // getDashboardRoute(): string {
  //   const isAdmin = this.user?.userRoles?.some(ur => ur.role?.name === 'Admin')
  //   return isAdmin ? eps.dashboardPath : eps.employeeDashboardPath
  // }

  getDashboardRoute(user?: any): string {
    const isAdmin = user?.userRoles?.some((ur: any) => ur?.role?.name === 'Admin') ?? false
    return isAdmin ? eps.dashboardPath : eps.employeeDashboardPath
  }
  isAdmin(): boolean {
    // return this.user?.role === 'Admin'
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Admin') ?? false
  }

  isBusinessOwner(): boolean {
    // return this.user?.role === 'Admin'
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Business Owner') ?? false
  }

  getLocation(): Promise<{ latitude: number; longitude: number } | null> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            if (position) {
              console.log(
                'Latitude:',
                position.coords.latitude,
                'Longitude:',
                position.coords.longitude
              )
              resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              })
            } else {
              resolve(null)
            }
          },
          error => {
            console.error('Geolocation error:', error)
            resolve(null) // Resolve as null on error instead of rejecting
          }
        )
      } else {
        console.warn('Geolocation is not supported by this browser.')
        resolve(null)
      }
    })
  }

  getDeviceInfo() {
    const userAgent = navigator.userAgent
    const platform = navigator.platform
    const deviceType = /mobile/i.test(userAgent)
      ? 'Mobile'
      : /tablet|ipad/i.test(userAgent)
        ? 'Tablet'
        : 'Desktop'

    return {
      userAgent,
      platform,
      deviceType
    }
  }

  generateToken(): string {
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      const bytes = new Uint8Array(16)
      crypto.getRandomValues(bytes)

      // Format to UUID v4
      bytes[6] = (bytes[6] & 0x0f) | 0x40
      bytes[8] = (bytes[8] & 0x3f) | 0x80

      const token = [...bytes]
        .map(
          (b, i) =>
            (i === 4 || i === 6 || i === 8 || i === 10 ? '-' : '') + b.toString(16).padStart(2, '0')
        )
        .join('')

      localStorage.setItem('device_token', token)
      return token
    } else {
      // fallback if crypto not available
      const token = 'xxxxxxxyxxxxxxxxyxxxxxyxxxxyxxxyx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
      localStorage.setItem('device_token', token)
      return token
    }
  }
}
